<template>
  <div>
    <b-table
      :items="skuConfigurations"
      :fields="fields"
      small
      class="bordered table-no-minheight"
      show-empty
      :empty-text="$t('Nenhuma configuração cadastrada')"
      responsive
      striped
    >
      <template #cell(actions)="{ item }">
        <e-grid-actions
          v-if="!isReadOnly"
          :show-update="true"
          :show-delete="true"
          @delete="$emit('delete-configuration', item)"
          @update="$emit('update-configuration', item)"
        />
        <span v-if="item.storeId === -1 || isReadOnly">-</span>
      </template>
    </b-table>
    <b-row class="mt-2">
      <b-col 
        md="12" 
        class="text-right"
      >
        <e-button
          v-if="!isReadOnly"
          variant="primary"
          icon="plus-circle"
          :text="$t('Adicionar Estoque Mínimo')"
          @click="$emit('add-configuration')"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>

import { BTable, BRow, BCol } from 'bootstrap-vue'
import { mapGetters, mapState } from 'vuex'
import { EGridActions, EButton } from '@/views/components'

export default {
  name: 'ConfigurationTable',
  components: { BTable, BRow, BCol, EButton, EGridActions },
  props: {
  },
  data() {
    return {
      fields: [
        { key: 'actions', label: this.$t('Ações'), thStyle: 'width: 100px;', tdClass: 'text-center', },
        { key: 'storeId', label: this.$t('Loja'),
          formatter: (value, key, item) =>
            !value ? 'Geral' :
            this.$options.filters.storeName({ id: item.storeId })
        },
        { key: 'minimumStock', label: this.$t('Estoque Mínimo') },
      ],
    }
  },
  computed: {
    ...mapState('pages/catalog/products/productMaintain', ['product', 'isReadOnly']),
    ...mapGetters('pages/catalog/products/productMaintain', ['skuConfigurations']),
    ...mapGetters('app', ['storeOptions']),
  },
  methods: {
    getStoreName(storeId) {
      // TODO: Implementar busca do nome da loja pelo ID
      return storeId
    },
  },
}
</script>

<style scoped></style>
